import React from "react";
import { useController } from "react-hook-form";
import TextField from "@mui/material/TextField";

const CustomCreditInput = (props) => {
  const { source, label } = props;
  const { field } = useController({
    name: source,
  });

  const displayValue =
    field.value !== undefined && field.value !== "" ? field.value / 100 : "";

  return (
    <TextField
      {...field}
      label={label}
      value={displayValue}
      inputProps={{
        inputMode: "numeric",
        pattern: "[0-9]*",
      }}
      onChange={(e) => {
        const val = e.target.value;
        if (/^\d+$/.test(val) || val === "") {
          // Convert UI value to API value
          field.onChange(val === "" ? "" : parseInt(val, 10) * 100);
        }
      }}
    />
  );
};

export default CustomCreditInput;
